export default __webpack_public_path__ + "static/media/mobile.d3967dea.png";